import React from 'react'
import startCase from 'lodash/startCase'
import Box from '@material-ui/core/Box'
import Divider from '@material-ui/core/Divider'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import makeStyles from '@material-ui/core/styles/makeStyles'
import {
  formatEventDate,
  formatEventTime,
} from 'lib/family-cup-utils/event-dates'
import useIsMobile from 'components/program-marketing/useIsMobile'

const useStyles = makeStyles(theme => ({
  card: {
    width: '100%',
    boxShadow: 'none',
    border: '1px solid #DBDCDD',
    boxSizing: 'border-box',
    borderRadius: '10px',
    display: 'flex',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marignLeft: 0,
    marginRight: 0,
    fontFamily: 'PlusJakarta Display',
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marignLeft: 0,
    marginRight: 0,
    background: '#000000',
  },
  grayBackground: {
    background: theme.palette.grey[100],
    border: '1px solid',
    borderColor: theme.palette.grey[100],
    boxSizing: 'border-box',
    borderRadius: '4px',
    padding: '8px 18px 8px 18px',
    fontSize: '14px',
    lineHeight: '18px',
    textWrap: 'nowrap',
  },
  largeFont: {
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '40px',
    lineHeight: '52px',
    minWidth: '52px',
    textAlign: 'center',
  },
  eventDetails: {
    height: '100%',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      flexWrap: 'nowrap',
    },
  },
  eventDetailsText: {
    lineHeight: '20px',
    [theme.breakpoints.only('xs')]: {
      fontSize: '14px',
    },
  },
}))

const Event = ({ event }) => {
  const isMobile = useIsMobile()
  const classes = useStyles()
  const [month, day] = formatEventDate(event, 'MMM d').split(' ')
  const eventTime = formatEventTime(event)
  return (
    <div className={classes.card}>
      <Grid item style={{ display: 'flex' }}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          py={2}
          px={isMobile ? 2 : 3}
        >
          <Typography variant="h6">{month}</Typography>
          <Typography className={classes.largeFont}>{day}</Typography>
        </Box>
      </Grid>
      <Divider className={classes.divider} flexItem orientation="vertical" />
      <Grid item style={{ flexGrow: '1' }}>
        <Grid
          container
          justify="space-between"
          alignItems="center"
          className={classes.eventDetails}
        >
          <Grid item style={{ flex: '1 1 auto' }}>
            <Box mb={isMobile ? 1 : 0}>
              <Typography variant="h3">
                {startCase(event.eventType.toLowerCase())}
              </Typography>
              <Typography
                variant="body1"
                color="textPrimary"
                className={classes.eventDetailsText}
              >
                {eventTime}
              </Typography>
              {event.description && (
                <Typography
                  variant="body1"
                  color="textPrimary"
                  className={classes.eventDetailsText}
                >
                  {event.description}
                </Typography>
              )}
              {event.details && (
                <Box mt={2}>
                  <Typography
                    variant="body1"
                    color="textPrimary"
                    className={classes.eventDetailsText}
                  >
                    <strong>Details:</strong> {event.details}
                  </Typography>
                </Box>
              )}
            </Box>
          </Grid>
          <Grid item style={{ minWidth: '150px' }}>
            {event.numberOfHoles !== 0 && (
              <Typography variant="body1" className={classes.grayBackground}>
                {event.numberOfHoles} Hole{' '}
                {startCase(event.eventType.toLowerCase())}
              </Typography>
            )}
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

export default Event
